export default "__VITE_ASSET__Cu6Lai7j__"